export interface URLS {
  BASE: string;
  FIRST_ACCESS_WIZARD: string;
  LOGIN: string;
  SIGNUP: string;
  DASHBOARDS: string;
  PROPERTIES: string;
  ASSETMANAGEMENT: string;
  CONTROLS: string;
  PROPERTYSERVICES: string;
  ALARMS: string;
  ALARMSLIST: string;
  ALARMSLOGS: string;
  REPORTS: string;
  SETTINGS: string;
  ACCOUNT: string;
  NOTIFICATIONS: string;
  GENERAL: string;
  USERS: string;
  DEVICES: string;
  GROUPS: string;
  MANUALCONTROL: string;
  AUTOMATIONS: string;
  BENCHMARKS: string;
  COSTSTARIFFS: string;
  CONFIGURED: string;
  LOGS: string;
  UNAUTHORIZED: string;
  USERlOGS: string;
  TEST?: string; // TODO: temporaneo
  REPORT_TEMPLATE_PRINT_PAGE: string;
}
export const URLS: URLS = {
  BASE: '/',
  FIRST_ACCESS_WIZARD: 'wizard',
  LOGIN: 'login',
  SIGNUP: 'sign-up',
  DASHBOARDS: 'dashboard',
  PROPERTIES: 'properties',
  ASSETMANAGEMENT: 'asset-management',
  CONTROLS: 'controls',
  PROPERTYSERVICES: 'property-services',
  ALARMS: 'alarms',
  ALARMSLIST: 'list',
  ALARMSLOGS: 'logs',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  ACCOUNT: 'account',
  NOTIFICATIONS: 'notifications',
  GENERAL: 'general',
  USERS: 'users',
  DEVICES: 'devices',
  GROUPS: 'groups',
  MANUALCONTROL: 'manual-control',
  AUTOMATIONS: 'automations',
  BENCHMARKS: 'benchmarks',
  COSTSTARIFFS: 'costs-tariffs',
  CONFIGURED: 'configured',
  LOGS: 'logs',
  USERlOGS: 'user-logs',
  UNAUTHORIZED: 'unauthorized',
  TEST: 'test', // TODO: temporaneo
  // FIXME: it would be better to have a function that returns the URL given the parameters, so that TypeScript
  // can validate the code more thoroughly
  REPORT_TEMPLATE_PRINT_PAGE: 'report-template-print-page/:reportId/:reportTitle',
};
